<template>
  <form-component ref="form" class="settings-page container">
    <div class="row">
      <div class="col">
        <div class="box">
          <h4>Instellingen</h4>
          <p v-if="endTimeErrorMessage" class="errorMessage">{{ endTimeErrorMessage }}</p>
          <datetime v-model="walkSettings.endTime"
                    type="datetime"
                    zone="local"
                    value-zone="local"
                    input-id="startDate"
                    input-style="width: 100%;
                                  border: 1px solid #d8dbe1;
                                  border-radius: 3px;
                                  height: 52px;
                                  padding: 1rem;">
            <label for="startDate" slot="before">Eindtijd</label>
          </datetime>
          <input-component :disabled="true" label="Anonieme cliëntcode" v-model="client.initials"></input-component>
          <input-component :disabled="true" type="number" label="Te laat mogen komen tijd in minuten" v-model="client.allowedMinutesToLate"></input-component>
          <label for="location">Woonlocatie</label>
          <select id="location" class="form-control" v-model="client.location" disabled>
            <option v-if="client.location" :value="client.location">
              {{ client.location.locationName }}
            </option>
          </select>
        </div>
      </div>

      <div class="col">
        <div class="box">
          <h4>Smartwatch instellingen</h4>
          <switch-component
                  :checked="client.emergencyEnabled"
                  label="Paniek knop"
                  @click.native="onPanicEnabledClicked">
          </switch-component>
        </div>
      </div>
      <div class="col">
        <div class="box">
          <h4>Contacten</h4>
          <div class="add-contacts">
            <div :key="i" v-for="(contact, i) in client.contacts">
              <input-component :disabled="true" required="required" label="Naam" v-model="contact.contactName"></input-component>
              <input-component :disabled="true" required="required" label="Nummer" v-model="contact.phoneNumber"></input-component>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button-component @click.native="onSaveClick">Gebied instellen</button-component>
  </form-component>
</template>

<script>
import { mapGetters } from 'vuex';
import TitleComponent from '../components/title.component.vue';
import FormComponent from '../components/fields/form.component.vue';
import InputComponent from '../components/fields/input.component.vue';
import SwitchComponent from '../components/fields/switch.component.vue';
import ButtonComponent from '../components/button.component.vue';
import { RouteName } from '../utils/enums';
import { Client } from '../domain/client';
import { WalkSettings } from '../domain/walk.settings';
import { Smartwatch } from "../domain/smartwatch";
import { Walk } from "../domain/walk";
import { Datetime } from 'vue-datetime';
import { DateTime as DateTimeUtil }  from 'luxon';

export default {
  name: 'settings-page',
  components: {
    FormComponent,
    InputComponent,
    SwitchComponent,
    ButtonComponent,
    Datetime
  },
  data() {
    return {
      client: Client,
      smartwatch: Smartwatch,
      walkSettings: WalkSettings,
      walk: Walk,
      endTimeErrorMessage: null,
      color: {
        hue: 50,
        saturation: 100,
        luminosity: 50,
        alpha: 1
      }
    };
  },
  computed: {
    ...mapGetters(['getClientToConnect', 'getSmartwatchToConnect'])
  },

    created() {
        this.client = this.getClientToConnect;
        this.smartwatch = this.getSmartwatchToConnect;
        this.walkSettings = {};
        this.walk = {};
    },

  methods: {
    removeContact(index) {
      this.client.contacts.splice(index, 1);
    },
    onPanicEnabledClicked: function() {
      this.client.emergencyEnabled = !this.client.emergencyEnabled;
    },
    onSaveClick: function() {
      if (this.validateForm()) {
        this.walk = {
          smartwatch: this.smartwatch,
          client: this.client,
          walkSettings: this.walkSettings
        };
        this.$store.dispatch('SET_NEW_WALK', this.walk);
        this.$router.push({ name: RouteName.CONNECT_SELECT_MAP_AREA });
      }
    },
    validateForm() {
      this.walkSettings.endTime === '' ? this.endTimeErrorMessage = 'Eindtijd is verplicht' : this.endTimeErrorMessage = null;
      return !this.endTimeErrorMessage;
    }
  }
};
</script>
<style scoped lang="scss">
  @import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
  @import "../../node_modules/vue-datetime/dist/vue-datetime.css";

.row {
  flex-direction: column;

  @include desktop {
    flex-direction: row;
  }
}

.box {
  margin-bottom: 2rem;

  @include desktop {
    background-color: $white;
    // height: 100%;
    padding: 1rem;
    box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.25rem;
  }

  h4 {
    font-weight: 400;
    margin-bottom: 1rem;
    color: $gray-darkest;
  }

  p {
    color: $gray-dark;
  }
  .errorMessage {
    color: $error;
    font-size: 12px;
    font-weight: normal;
    margin-bottom: 0;
  }
}

.add-contacts {
  border-radius: 4px;
  border: 1px solid $gray;
  padding: 1rem;
  position: relative;
  margin-bottom: 1rem;

  .add-button {
    $button-size: 42px;
    position: absolute;
    bottom: -($button-size / 2);
    left: 50%;
    margin-left: -($button-size / 2);
    width: $button-size;
    height: $button-size;
    border-radius: 50%;
    background-color: $primary;
  }
  p {
    color: red;
    font-weight: bold;
    margin-bottom: 0px;

    &:hover {
      cursor: pointer;
    }
  }
}

.subtitle {
  margin: 1rem 0;
  display: block;
  font-weight: 500;
}

.seperator {
  margin: 2rem 0;
  background-color: $gray;
}

.input-component,
.switch-component {
  margin-bottom: 1rem;
}

.row-wrapper {
  display: flex;

  .input-component {
    flex-grow: 1;

    &:first-child {
      margin-right: 60px;
    }
  }
}

.smartwatch-bg-color {
  margin-bottom: 1rem;
}

  select {
    width: 100%;
    border: 1px solid $gray;
    border-radius: 3px;
    height: 52px;
    padding: 1rem;
  }

// TODO: Replace the use our custom input element inside gmap: https://github.com/xkjyeah/vue-google-maps/issues/182
.input-component.gmap {
  input {
    width: 100%;
    border: 1px solid $gray;
    border-radius: 3px;
    height: 52px;
    padding: 0 8px;
  }

  label {
    display: block;
    color: $gray-dark;
  }

  .error {
    color: $error;
    font-size: 12px;
  }
}
</style>
